var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page contact-me uk-container"},[_vm._m(0),_c('div',{staticClass:"content form"},[_c('contact-form')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign uk-text-center"},[_c('span',{staticClass:"sign-1"},[_vm._v("Contact")]),_c('span',{staticClass:"sign-2"},[_vm._v(" Me")])])
}]

export { render, staticRenderFns }